import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

class CoreHomepage {
    sections = [
        ...gsap.utils.toArray(".ncst-homepage-header"),
        ...gsap.utils.toArray(".ncst-homepage-container")
    ];
    unityBarOffset = $('.site-title').height();
    ncstBlocksToReveal = [
        'wp-block-ncst-events',
        'wp-block-ncst-video-image',
        'wp-block-ncst-curated-news-list',
        'wp-block-ncst-fact-card',
        'wp-block-ncst-homepage-shortcode'
    ];

    constructor() {
        this.hide = this.hide.bind(this);
        this.animateFrom = this.animateFrom.bind(this);
        this.chevronClick = this.chevronClick.bind(this);
        this.applyMobileLayout = this.applyMobileLayout.bind(this);
        this.bindToScrollTrigger = this.bindToScrollTrigger.bind(this);
        this.documentEventListener = this.documentEventListener.bind(this);

        $(window).on('resize', this.applyMobileLayout);
        $(document).on('click', '#header-chevron', this.chevronClick);
        $(document).on('DOMContentLoaded', this.documentEventListener);
    }

    hide(elem) {
        gsap.set(elem, {autoAlpha: 0});
    }

    animateFrom(elem) {
        let x = 0,
            y = 100;

        elem.style.transform = "translate(" + x + "px, " + y + "px)";
        elem.style.opacity = "0";

        gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0}, {
            duration: 1.25, 
            x: 0,
            y: 0, 
            autoAlpha: 1, 
            ease: "expo", 
            overwrite: "auto"
        });
    }

    bindToScrollTrigger(elem) {
        this.hide(elem); // assure that the element is hidden when scrolled into view

        ScrollTrigger.create({
            once: true,
            start: "top 70%",
            end: "top 70%",
            // markers: true,
            trigger: elem,
            onEnter: () => { this.animateFrom(elem) },
            onEnterBack: () => { this.animateFrom(elem, -1) },
            // onLeave: function() { hide(elem) } // assure that the element is hidden when scrolled into view
        });
    }

    documentEventListener() {
        this.ncstBlocksToReveal.forEach(function(block) {
            $(`.${block}`).addClass('gs_reveal');
        });

        // ------------------
        // special use cases
        // ------------------
        $('.ncst-column .wp-block-ncst-spotlight-card').each(function() {
            if (!$(this).parent().hasClass('ncst-spotlight-card-list__container')) {
                $(this).addClass('gs_reveal');
            }
        });
        // ------------------

        gsap.utils.toArray(".gs_reveal").forEach(this.bindToScrollTrigger);
    }

    chevronClick() {
        let sectionIndex = 1;  // index of section to jump to

        /*
         * NOTE: as of gsap v3.11 -- this approach doesn't work on latest iphone devices (14 pro + 14 pro max)
         */
        // gsap.to(window, {
        //     scrollTo: { y: sectionIndex * this.sections[sectionIndex].offsetTop + this.unityBarOffset, autoKill: false },
        //     duration: 1
        // });

        // jQuery solution from the above mentioned bug
        $('html, body').animate(
            { scrollTop: sectionIndex * this.sections[sectionIndex].offsetTop, },
            1000,
            'swing'
        );
    }

    applyMobileLayout() {
        if(window.innerWidth <= 991) {
            let order = 0;

            $('.wp-block-ncst-homepage-container').each(function(index, elm) {
                if ( $(this).find('.wp-block-ncst-homepage-statement').length ) {

                    // Rearrange block priority/order depending if homepage-statement is present.
                    // Only applies on mobile devies.
                    $(this).find('.ncst-column').each(function(index, elm) {
                        if( $(this).find('.wp-block-ncst-homepage-statement').length ) {
                            $(this).css('order', 0);
                        } else if ( !$(this).find('.wp-block-ncst-homepage-statement').length ) {
                            $(this).css('order',  1);
                        }
                    });

                }
            });

        } else {
            $('.ncst-column').removeAttr('style');
        }
    }
}

new CoreHomepage();
